<template>
    <div>
        <kt-datatable ref="datatable" v-bind="datatableProps">
        </kt-datatable>
    </div>
</template>

<script>
    import {ApiUrl} from "@/common/api.service";
    import {AuthorizationHeader} from "@/common/jwt.service";
    import columns from "../datatable/transaction-columns.js";

    export default {
        data() {
            return {
                query: {},
            };
        },
        methods: {
            filterAction(e, query) {
                this.query = query;

                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
        },
        computed: {
            datatableProps() {
                return {
                    id: "wallets_transactions_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('wallet/common/admin/transactions/D'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: res => {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            }
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                }
            },
        },
    }
</script>
